module.exports = __webpack_public_path__ + "static/media/Cremonese.7a08bec8.png";